<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
                <h4 class="personal-details-title">Modify Customer APK</h4>
                <table class="table table-striped">
                    <thead>
                        <tr>
                        <th scope="col">#</th>
                        <th scope="col">APK Description</th>
                        <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let keyvalue of allCustomer | paginate : {
                            itemsPerPage: tableSize,
                            currentPage: page,
                            totalItems: count
                          } ;let i = index">
                        <th scope="col">{{i+1}}</th>
                        <th scope="col">{{keyvalue.description}}</th>
                        <th>
                            <svg (click)="getCustomerAPKById(keyvalue.customerAPKVersionId)" data-toggle="modal" data-target="#updateTemplate" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                              </svg>
                          </th>
                        </tr>
                    </tbody>
                </table>
                <div class="pagination-block" *ngIf="allCustomer.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                  </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="updateTemplate" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Update Customer APK
                <span data-dismiss="modal">
                    <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                </span>
            </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="objectForm">
                    <div class="col-md-12 col-lg-12 des">
                        <label>Description</label>
                        <textarea formControlName="description" class="form-control" name="" id="" cols="30" rows="10"></textarea>
                    </div>

                    <div formArrayName="keyValueList">
                        <div *ngFor="let object of objectForm.controls.keyValueList['controls'];let i = index;let last = last" [formGroupName]="i">
                            <div class="row">
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <input formControlName="key" placeholder="enter key" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-5 col-lg-5">
                                    <div class="form-group">
                                        <input formControlName="value" placeholder="enter value" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-1 col-lg-1 paramBtn" *ngIf="last">
                                    <svg xmlns="http://www.w3.org/2000/svg" (click)="addkeyValue()" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" *ngIf="i!=0" (click)="removekeyValue(i)" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                                    </svg>
                                </div>
                                <div class="col-md-1 col-lg-1 paramBtn1" *ngIf="!last">
                                    <svg xmlns="http://www.w3.org/2000/svg" (click)="removekeyValue(i)" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton2"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" (click)="updateCustomerAPK()" class="btn btn-primary">save changes</button>
                </div>
            </div>
        </div>
    </div>
</div>
